import {apiBase} from 'api/base.js';

class SessionAPI {
  create(params) {
    return apiBase.request('/admin/session', 'POST', params, false);
  }
}

export const sessionAPI = new SessionAPI();
